/**
 * Type definitions for the security module.
 *
 * @remarks
 * These interfaces define inputs and outputs for unsigned transaction verification
 * and intent hashing helpers used across staking and generic transaction flows.
 *
 * @packageDocumentation
 */
/**
 * Enum of supported security verification operations.
 * Add new operations here when extending the security module.
 */
export var StakewiseOperationsEnum;
(function (StakewiseOperationsEnum) {
    StakewiseOperationsEnum["STAKE"] = "stake";
    StakewiseOperationsEnum["WITHDRAW"] = "withdraw";
    StakewiseOperationsEnum["CLAIM_EXIT_QUEUE"] = "claimExitQueue";
    StakewiseOperationsEnum["GENERIC"] = "generic";
    StakewiseOperationsEnum["UNKNOWN"] = "unknown";
})(StakewiseOperationsEnum || (StakewiseOperationsEnum = {}));
/**
 * Enum of Solana-specific security verification operations.
 * Used for Solana native staking transaction verification.
 */
export var SolanaOperationsEnum;
(function (SolanaOperationsEnum) {
    SolanaOperationsEnum["STAKE"] = "solana_stake";
    SolanaOperationsEnum["WITHDRAW"] = "solana_withdraw";
    // prepare to withdraw
    SolanaOperationsEnum["DEACTIVATE"] = "solana_deactivate";
})(SolanaOperationsEnum || (SolanaOperationsEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbWFpbi9tb2R1bGVzL3NlY3VyaXR5L3R5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OztHQVFHO0FBVUg7OztHQUdHO0FBQ0gsTUFBTSxDQUFOLElBQVksdUJBTVg7QUFORCxXQUFZLHVCQUF1QjtJQUNqQywwQ0FBZSxDQUFBO0lBQ2YsZ0RBQXFCLENBQUE7SUFDckIsOERBQW1DLENBQUE7SUFDbkMsOENBQW1CLENBQUE7SUFDbkIsOENBQW1CLENBQUE7QUFDckIsQ0FBQyxFQU5XLHVCQUF1QixLQUF2Qix1QkFBdUIsUUFNbEM7QUFFRDs7O0dBR0c7QUFDSCxNQUFNLENBQU4sSUFBWSxvQkFLWDtBQUxELFdBQVksb0JBQW9CO0lBQzlCLDhDQUFzQixDQUFBO0lBQ3RCLG9EQUE0QixDQUFBO0lBQzVCLHNCQUFzQjtJQUN0Qix3REFBZ0MsQ0FBQTtBQUNsQyxDQUFDLEVBTFcsb0JBQW9CLEtBQXBCLG9CQUFvQixRQUsvQiJ9